import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@arcadeai/design-system/components/ui/atoms/alert";
import { FlaskConical } from "lucide-react";

/**
 * Alpha-status banner for the end-user tools surfaces — the end-user dashboard
 * (`/eu`) and the admin "End-user tools" tab. Signals that the feature is an
 * early preview whose behavior and saved data may change while it is built out.
 */
export const AlphaBanner = () => (
  <Alert variant="warning">
    <FlaskConical />
    <AlertTitle>Alpha</AlertTitle>
    <AlertDescription>
      This is an alpha project — the experience and any saved data may change or
      be reset while we build it out.
    </AlertDescription>
  </Alert>
);
